import { defineMessages } from 'react-intl-next';
var messages = defineMessages({
  newLozenge: {
    id: 'fabric.atlassianSwitcher.newLozenge',
    defaultMessage: 'New',
    description: 'The lozenge text for a lozenge indicating a new switcher item'
  }
});
export default messages;